import { Divider, Stack } from '@mui/material'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

import { roundingNumber } from 'components/shared/processes'
import { BaseWidget } from '../../../baseWidget'

export const PsvHerdStructureWidget = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()
	if (!permissions?.license_food_table || error) return null

	const psvMilkCows = statistics?.psv_milk_cows?.count
	const psvDryCows = statistics?.psv_dry_cows?.count

	return (
		<BaseWidget
			// path={'/feed/'}
			isLoading={loading}
			// pathLable='Перейти в кормовой стол'
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='column' gap='4px'>
					<Stack direction='row' gap='4px' alignItems='center'>
						{(psvMilkCows || psvMilkCows === 0) && (
							<TypographyPrimary16Bold>
								{roundingNumber(psvMilkCows, 1).toLocaleString()}
							</TypographyPrimary16Bold>
						)}
						<TypographySecondary>кг/голову</TypographySecondary>
					</Stack>
					<TypographyPrimary>ПСВ дойных голов</TypographyPrimary>
				</Stack>

				<Divider />

				<Stack direction='column' gap='4px'>
					<Stack direction='row' gap='4px' alignItems='center'>
						{(psvDryCows || psvDryCows === 0) && (
							<TypographyPrimary16Bold>
								{roundingNumber(psvDryCows, 1).toLocaleString()}
							</TypographyPrimary16Bold>
						)}
						<TypographySecondary>кг/голову</TypographySecondary>
					</Stack>
					<TypographyPrimary>ПСВ сухостойных голов</TypographyPrimary>
				</Stack>
			</Stack>
		</BaseWidget>
	)
}
